"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@rmlibrary/animate-components");
require("./video");
var logic_1 = require("./logic");
var utilities_1 = require("./utilities");
var pdf_1 = require("./pdf");
var videoContainer = document.getElementsByTagName("rm-dynamic-video")[0];
// const data = getVideoData();
var embedMode = (0, utilities_1.hasQueryStringInURL)("embed");
// videoContainer.initVideo(data, embedMode);
if (embedMode) {
    addEventListener("message", function (_a) {
        var type = _a.data.type;
        (0, pdf_1.setupPDF)();
        switch (type) {
            case "play_video": {
                videoContainer.playVideo();
                break;
            }
            case "reset_video": {
                videoContainer.resetVideo();
                break;
            }
            case "update_video_data": {
                var videoData = (0, logic_1.getVideoData)();
                videoContainer.updateVideoData(videoData);
                break;
            }
        }
    });
}
//# sourceMappingURL=module.js.map